import { configureTracking } from '@zapier/toolbox-tracking';

const initializeTracking = config => {
  const { commitHash } = config;

  configureTracking({
    // Since the editor is client side for now, set service to 'web'.
    // See https://zapier.slack.com/archives/C406QGE15/p1605895155293500 for more context.
    service: 'web',
    release: commitHash || '<unknown>',
  });
};

export default initializeTracking;
